import { render, staticRenderFns } from "./NumericKeyboard.vue?vue&type=template&id=20d46c06&scoped=true"
import script from "./NumericKeyboard.vue?vue&type=script&lang=js"
export * from "./NumericKeyboard.vue?vue&type=script&lang=js"
import style0 from "./NumericKeyboard.vue?vue&type=style&index=0&id=20d46c06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d46c06",
  null
  
)

export default component.exports